setTimeout(() => {
  if(BSS_B2B){
   const btns = document.querySelectorAll("[bss-b2b-btn-quickview]");
    if(btns.length){
      btns.forEach(btn => {
        const modal = btn.closest('modal-opener');
        let productId = '';
        if(modal){
          const data_modal = modal.getAttribute('data-modal')?.replace('#QuickAdd-', '');
          if(data_modal){
            productId = data_modal;
          }
        }
        btn.addEventListener('click',  () => {
          setTimeout(async() => {
            if(!BSS_B2B.storage.productStorage.get(Number(productId))){
              await BSS_B2B.storage.productStorage.load();
            }
            let interval = setInterval(() => {
               if(productId.length && BSS_B2B.storage.productStorage.get(Number(productId))){
                 clearInterval(interval)
                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`, { bubbles: true }));
                 
               }
             }, 500)

          setTimeout(() => {clearInterval(interval)}, 5000)
          }, 2000)
        })
      })
    }
  }
}, 200)